module.exports = __webpack_public_path__ + "img/user-account.aee6adef.png";